<template>
  <div class="all-box equity-box equity-container">
    <Header :title="title" />
    <section class="dzclubs-all-wrap">
      <el-skeleton
        animated
        :loading="loading"
        :count="5"
        style="width: 96%; margin: 0 auto 10px"
      >
        <template #template>
          <el-skeleton-item
            variant="text"
            style="
              width: 100%;
              height: 128px;
              margin: 10px auto;
              border-radius: 10px;
            "
          />
        </template>
        <template #default>
          <el-row :align="'middle'" class="dzclubs-item-wrap">
            <el-col
              :span="24"
              class="equity-items"
              v-for="(item, key) in equityData"
              :key="key"
            >
              <input type="hidden" :value="item.serverId" />
              <img :src="require('@/assets/' + item.cardImg + '.png')" alt="" />
              <div class="equity-items-header">
                <div class="equity-title">
                  <img src="@/assets/equityIcon.png" alt="" />
                  <h1>{{ item.title }}</h1>
                </div>
                <div class="equity-header-btn abs">
                  <el-button
                    :disabled="item.exChange"
                    @click="open(item.canActive, item.serverId, item.content)"
                    v-if="item.routerLink == ''"
                  >
                    {{ item.exChange ? "已兑换" : "兑换" }}
                  </el-button>
                  <router-link
                    :to="{
                      name: 'ZfMsg',
                    }"
                    v-else
                  >
                    <el-button>我的祝福语</el-button>
                  </router-link>
                </div>
              </div>
              <el-row :align="'middle'" class="equity-items-body" v-if="false">
                <el-col :span="8" class="equity-body-item">
                  <p>达成条件</p>
                  <p>{{ item.condition }}</p>
                </el-col>
                <el-col :span="8" class="equity-body-item">
                  <p>兑换状态</p>
                  <p
                    class="exChangeColor"
                    :class="{ 'equity-text-active': item.exChange }"
                  >
                    {{ item.exChange ? "已兑换" : "未兑换" }}
                  </p>
                </el-col>
                <el-col :span="8" class="equity-body-item">
                  <el-button
                    type="danger"
                    :disabled="item.exChange"
                    @click="open(item.canActive, item.serverId, item.content)"
                  >
                    兑换
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </template>
      </el-skeleton>
      <div class="allDialog">
        <el-dialog
          title="提示"
          v-model="showDialog"
          width="70%"
          top="36vh"
          :show-close="false"
          center
        >
          <span>
            <span>{{ content }}</span>
          </span>
          <template #footer>
            <div class="dialog-footer">
              <el-button @click="showDialog = false">取 消</el-button>
              <el-button @click="getDialogChange">兑 换</el-button>
            </div>
          </template>
        </el-dialog>
      </div>
    </section>
  </div>
</template>

<script>
import { ref } from "vue";

import Header from "@/components/util/Header";

export default {
  name: "Equity",
  data() {
    return {
      title: "权益中心",
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      wx: {
        uid: 0,
        openid: "",
        nickname: "",
        headimgurl: "",
        userToken: "",
      },
      equityData: [
        {
          title: "新民祝福语权益",
          condition: "积分≥360",
          exChange: false,
          serverId: "",
          content: "",
          routerLink: "/zfmsg",
          canActive: true,
          cardImg: "equityImg2",
        },
        {
          title: "新晋会员权益",
          condition: "新用户注册",
          exChange: false,
          serverId: "newuser",
          content: "请在领取权益赠品时候点击兑换",
          routerLink: "",
          canActive: true,
          cardImg: "equityImg0",
        },
        {
          title: "VIP激活权益",
          condition: "订阅激活码",
          exChange: false,
          serverId: "newvip",
          content: "请在领取权益赠品时候点击兑换",
          routerLink: "",
          canActive: true,
          cardImg: "equityImg1",
        },
      ],
      new_user: 1,
      new_vip: 0,
      equityRegData: {
        name: "",
        passPort: 0,
      },
      swContentData: [
        {
          contentStatus: 0,
        },
      ],
      storage: window.localStorage,
    };
  },
  setup() {
    const showDialog = ref(false);
    const showActive = ref(false);
    const serverId = ref("");
    const content = ref("");
    const loading = ref(true);

    const open = (getKey, getServerId, getContent) => {
      showDialog.value = true;
      showActive.value = getKey;
      serverId.value = getServerId;
      content.value = getContent;
    };

    return {
      showDialog,
      showActive,
      serverId,
      content,
      loading,
      open,
    };
  },
  async mounted() {
    this.wx.uid = this.storage.getItem("uid");
    this.wx.userToken = this.storage.getItem("usertoken");

    await this.getUserInfo();
  },
  methods: {
    getDialogChange() {
      if (!this.showActive) {
        this.showDialog = false;
        this.$message.warning({
          message: "敬请期待",
          type: "warning",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
        return;
      }

      this.$axios
        .get(`/wxindex/user/${this.serverId}.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.equityData.filter(
              (item, index) => this.equityData[index].exChange == true
            );
            this.showDialog = false;
            this.getUserInfo();

            this.$message.success({
              message: response.data.message,
              type: "success",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
          } else {
            this.showDialog = false;

            this.$message.warning({
              message: response.data.message,
              type: "warning",
              center: true,
              offset: 90,
              duration: 1500,
              customClass: "message-class",
            });
          }
        });
    },
    getUserInfo() {
      this.$axios
        .get(`/wxindex/user/getinfo.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.new_user = response.data.userinfo.new_user;
            this.new_vip = response.data.userinfo.new_vip;

            /**
             * 东方明珠*/
            if (this.new_vip > 0 && response.data.userinfo.dongfmz > 0) {
              this.equityRegData.name = response.data.userinfo.dongfmz_realname;
              this.equityRegData.passPort = response.data.userinfo.passport;
            }
            this.swContentData[0].contentStatus =
              response.data.userinfo.dongfmz;

            for (let i in this.equityData) {
              /**
               * 新晋*/
              if (
                this.new_user == 3 &&
                this.equityData[i].title == "新晋会员权益"
              ) {
                this.equityData[i].exChange = true;
              }
              /**
               * vip*/
              if (
                this.new_vip == 2 &&
                this.equityData[i].title == "VIP激活权益"
              ) {
                this.equityData[i].exChange = true;
              }
            }

            /**
             * 判断兑换完毕，(新晋、vip)*/
            let changedItems = this.equityData.filter(
              (item, index) => this.equityData[index].exChange == true
            );
            let otherItems = this.equityData.filter(
              (item, index) => this.equityData[index].exChange == false
            );

            this.equityData = otherItems.concat(changedItems);
            this.loading = false;
          } else {
            window.location.href =
              "https://clubs.xinmin.cn/dzclub/index.html#/auth";
          }
        });
    },
  },
  components: {
    Header,
  },
};
</script>

<style>
.equity-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.equity-container .header-wrap {
  background-color: var(--f56c6c);
  color: var(--fff);
}

.equity-items {
  position: relative;
  overflow: hidden;
  margin: 10px auto;
}

.equity-items-header {
  display: -webkit-flex;
  align-items: flex-start;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
}

.equity-title {
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
  width: 100%;
}

.equity-title h1 {
  font-size: 22px;
  color: var(--fff);
}

.equity-title img {
  margin: 0 10px 0 5%;
  width: 25px;
}

.equity-header-btn {
  bottom: 8%;
  right: 5%;
}

.equity-header-btn button,
.equity-header-btn .el-button:focus,
.equity-header-btn .el-button:hover {
  min-width: 80px;
  color: var(--equity-header-btn-color);
  background-color: var(--equity-header-btn-bgcolor);
  border-radius: 10px;
  border: transparent;
  border-color: transparent;
}

.equity-items-body {
  padding: 0 2%;
  margin: 30px auto;
}

.equity-body-item p:first-child {
  font-size: 14px;
  padding-bottom: 5px;
}

.equity-body-item p:last-child {
  font-size: 16px;
  color: var(--equity-items-condition);
}

.equity-body-item p.exChangeColor {
  color: var(--ccc);
}

.equity-body-item p.equity-text-active {
  color: #67c23a;
}
</style>